import React, { lazy, Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

const PatientPageV3 = lazy(() =>
  import('@features/patient-page-v3').then(m => ({ default: m.PatientPageV3 })),
);

export const PatientPageRoute: React.FC = () => (
  <Suspense fallback={<CenteredSpinner sx={{ height: '50vh' }} />}>
    <PatientPageV3 />
  </Suspense>
);
